import { render, staticRenderFns } from "./profil.vue?vue&type=template&id=059efab6&scoped=true"
import script from "./profil.vue?vue&type=script&lang=js"
export * from "./profil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059efab6",
  null
  
)

export default component.exports